export type IShowFormGroupSuccess = (element: IjQueryElmOrHtmlElm) => void;

export function showFormGroupSuccess(element: IjQueryElmOrHtmlElm): void {
  const $formGroup = $(element).closest('.form-group');
  const $errorBlock = $formGroup.find('.error-block');
  $formGroup.removeClass('has-warning has-error').addClass('has-success');
  $errorBlock
    .addClass('hide')
    .attr('aria-hidden', 'true')
    .text('');
}
